/** @jsx jsx */
import { jsx } from "theme-ui"

import Pin from "../../atoms/Pin"

export default function HashtagHeading({styleSx, liveSubtitle}) {

  return (
    <div sx={styleSx}>
      <h3
        sx={{
          variant: "styles.root.h2",
          mb: 0,
        }}
        dir="ltr"
      >
        #mymark
        <span sx={{ color: "primary", fontWeight: 500 }}>mycity</span>
      </h3>
      <p
        sx={{
          variant: "text.body",
          mt: [0, -1],
        }}
      >
        {" "} {liveSubtitle} {" "}
        
      </p>
      <Pin icon="@" sx={{ px: 2 }}>
        Mymarkmycity
      </Pin>
    </div>
  )
}
